import theme from 'src/theme';

export const tableSx = {
    root: {
        mt: 1.5,
        borderRadius: '14px',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
        bgcolor: theme.palette.common.white,
        boxShadow: '0 1px 2px rgba(0,0,0,0.03), 0 4px 12px rgba(0,0,0,0.03)',
    },
    scrollArea: {
        width: '100%',
        overflowX: 'auto' as const,
        WebkitOverflowScrolling: 'touch' as const,
    },
    table: {
        width: '100%',
        tableLayout: 'auto' as const,
        borderCollapse: 'separate' as const,
        borderSpacing: 0,
        fontSize: '0.78rem',
        fontVariantNumeric: 'tabular-nums' as const,
        '& th, & td': {
            boxSizing: 'border-box' as const,
        },
    },
    thead: {
        bgcolor: '#FAFBFD',
    },
    th: {
        textAlign: 'left' as const,
        fontSize: '0.65rem',
        fontWeight: 700,
        color: theme.palette.neutral[400],
        textTransform: 'uppercase' as const,
        letterSpacing: '0.06em',
        py: 1,
        px: 1.5,
        whiteSpace: 'nowrap' as const,
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    },
    thSortable: {
        textAlign: 'left' as const,
        fontSize: '0.65rem',
        fontWeight: 700,
        color: theme.palette.neutral[400],
        textTransform: 'uppercase' as const,
        letterSpacing: '0.06em',
        py: 1,
        px: 1.5,
        whiteSpace: 'nowrap' as const,
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        boxSizing: 'border-box' as const,
        cursor: 'pointer',
        userSelect: 'none' as const,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    thInner: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.4,
        verticalAlign: 'middle' as const,
    },
    sortIcon: {
        fontSize: 12,
        opacity: 0.5,
    },
    sortIconActive: {
        fontSize: 12,
        opacity: 1,
        color: theme.palette.primary.main,
    },
    td: {
        px: 1.5,
        py: 1.1,
        color: theme.palette.neutral[800],
        borderBottom: '1px solid rgba(0, 0, 0, 0.04)',
        whiteSpace: 'nowrap' as const,
        verticalAlign: 'middle' as const,
        textAlign: 'left' as const,
    },
    tdLast: {
        borderBottom: 'none',
    },
    tdSubtle: {
        color: theme.palette.neutral[500],
        fontSize: '0.72rem',
    },
    tdPrimary: {
        fontWeight: 600,
        color: theme.palette.neutral[800],
    },
    cellStack: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: 0.15,
        minWidth: 0,
    },
    cellStackSub: {
        fontSize: '0.68rem',
        color: theme.palette.neutral[400],
        lineHeight: 1.2,
    },
    chip: {
        display: 'inline-flex',
        alignItems: 'center',
        px: 0.75,
        py: 0.15,
        borderRadius: '6px',
        fontSize: '0.64rem',
        fontWeight: 700,
        textTransform: 'uppercase' as const,
        letterSpacing: '0.05em',
        whiteSpace: 'nowrap' as const,
    },
    chipPaid: {
        bgcolor: 'rgba(28, 176, 125, 0.12)',
        color: '#0F7E55',
    },
    chipPending: {
        bgcolor: 'rgba(249, 171, 0, 0.14)',
        color: '#8C5A00',
    },
    chipUnpaid: {
        bgcolor: 'rgba(230, 41, 48, 0.10)',
        color: '#AD1F26',
    },
    chipNeutral: {
        bgcolor: theme.palette.neutral[100],
        color: theme.palette.neutral[500],
    },
    chipOnline: {
        bgcolor: 'rgba(28, 176, 125, 0.12)',
        color: '#0F7E55',
    },
    chipOffline: {
        bgcolor: theme.palette.neutral[100],
        color: theme.palette.neutral[500],
    },
    chipInfo: {
        bgcolor: 'rgba(0, 127, 220, 0.10)',
        color: '#005B9E',
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 2,
        py: 1,
        borderTop: '1px solid rgba(0, 0, 0, 0.04)',
        bgcolor: '#FAFBFD',
        flexWrap: 'wrap' as const,
    },
    footerLabel: {
        fontSize: '0.72rem',
        fontWeight: 500,
        color: theme.palette.neutral[500],
        lineHeight: 1,
    },
    footerValue: {
        fontSize: '0.72rem',
        fontWeight: 600,
        color: theme.palette.neutral[800],
        lineHeight: 1,
        fontVariantNumeric: 'tabular-nums' as const,
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        pt: 1.5,
        pb: 1,
        lineHeight: 1,
    },
    titleIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        borderRadius: '6px',
        bgcolor: 'rgba(0, 127, 220, 0.10)',
        color: theme.palette.primary.main,
        flexShrink: 0,
        '& svg': {
            fontSize: '14px',
            display: 'block',
        },
    },
    titleText: {
        fontSize: '0.82rem',
        fontWeight: 600,
        color: theme.palette.neutral[800],
        letterSpacing: '-0.01em',
        lineHeight: 1,
        display: 'inline-block',
    },
    titleCount: {
        ml: 'auto',
        fontSize: '0.7rem',
        fontWeight: 600,
        color: theme.palette.neutral[400],
        letterSpacing: '0.02em',
        lineHeight: 1,
        display: 'inline-block',
    },
};
